<template>
  <div>
    <CJumbotron
      style="background-size: cover; background-position: center"
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-xl-none"
    >
      <CRow>
        <CCol sm="12" lg="12">
          <div>
            <CRow>
              <CCol sm="8">
                <img
                  style="
                    max-width: 90%;
                    margin-top: 15%;
                    margin-left: 15%;
                    margin-bottom: 10%;
                    float: right;
                  "
                  src="../assets/img/subscription/banner1.svg"
                />
              </CCol>
              <CCol sm="4">
                <div style="width: 90%">
                  <br class="d-sm-down-none" /><br class="d-sm-down-none" />
                  <h1 class="font-weight-700 custom-h1-subscribe">PICKIDDO</h1>
                  <h4 class="font-weight-700 sub-header-subscribe">
                    ADMIN DASHBOARD
                  </h4>
                  <CCard color="default" class="bg-card-default">
                    <h4 class="custom-label-text p-2">
                      Are you a large organization or interested in registering
                      multiple students? Please kindly complete the form below.
                    </h4>
                    <div v-if="sectionemail === true">
                      <CRow class="text-center p-1 ml-3">
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle text-center float-right"
                            >1</span
                          >
                        </CCol>
                        <CCol sm="1" class="d-sm-down-none">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 100%"
                            class="mt-3"
                          />
                        </CCol>
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle-grey text-center float-right"
                            >2</span
                          >
                        </CCol>
                        <CCol sm="1" class="d-sm-down-none">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            class="mt-3"
                            style="max-width: 100%"
                        /></CCol>
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle-grey text-center float-right"
                            >3</span
                          ></CCol
                        >
                        <CCol sm="1" class="d-sm-down-none">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 100%"
                            class="mt-3"
                        /></CCol>
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle-grey text-center float-right"
                            >4</span
                          ></CCol
                        >

                        <br /><br />
                      </CRow>

                      <!-- <CRow class="mt-3 p-2" style="width: 100% !important">
                        <CCol sm="12">
                         <label>Enter your email</label><br />
                          <CInput
                            type="text"
                            placeholder="Enter your email"
                            size="lg"
                            v-model="Email"
                          />
                          <label>Enter your phone</label><br />
                          <CInput
                            type="text"
                            placeholder="Enter your phone"
                            size="lg"
                            v-model="Phone"
                          />
                          <CButton
                            type="button"
                            class="custom-btn-navy mt-3"
                            block
                            size="lg"
                            @click="GoToSecondForm()"
                            >Next
                            <img
                              style="max-width: 30px"
                              src="../assets/img/subscription/ArrowWhite.png"
                              class="ml-3"
                          /></CButton>
                        </CCol>
                      </CRow> -->
                      <CRow class="mt-3 p-2" style="width: 100% !important">
                        <CCol sm="12">
                          <label>Enter your email</label><br />
                          <CInput
                            type="text"
                            placeholder="Enter your email"
                            size="lg"
                            v-model="Email"
                          />
                          <label>Enter your phone</label><br />
                          <CInput
                            type="text"
                            placeholder="Enter your phone"
                            size="lg"
                            v-model="Phone"
                          />
                          <CButton
                            type="button"
                            class="custom-btn-navy mt-3"
                            block
                            size="lg"
                            @click="GoToSecondForm()"
                            >Next
                            <img
                              style="max-width: 30px"
                              src="../assets/img/subscription/ArrowWhite.png"
                              class="ml-3"
                          /></CButton>
                        </CCol>
                      </CRow>
                    </div>

                    <div v-if="sectionusername === true">
                      <CRow class="text-center p-1 ml-3">
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle text-center float-right"
                            >1</span
                          >
                        </CCol>
                        <CCol sm="1" class="d-sm-down-none">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 100%"
                            class="mt-3"
                          />
                        </CCol>
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle text-center float-right"
                            >2</span
                          >
                        </CCol>
                        <CCol sm="1" class="d-sm-down-none">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            class="mt-3"
                            style="max-width: 100%"
                        /></CCol>
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle-grey text-center float-right"
                            >3</span
                          ></CCol
                        >
                        <CCol sm="1" class="d-sm-down-none">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 100%"
                            class="mt-3"
                        /></CCol>
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle-grey text-center float-right"
                            >4</span
                          ></CCol
                        >

                        <br /><br />
                      </CRow>

                      <CRow class="mt-3 p-2" style="width: 100% !important">
                        <CCol sm="12">
                          <label>Enter your username</label><br />
                          <CInput
                            type="text"
                            placeholder="Enter your username"
                            size="lg"
                            v-model="Username"
                          />
                          <label>Enter your password</label><br />
                          <CInput
                            type="password"
                            placeholder="Enter your password"
                            size="lg"
                            v-model="Password"
                          />
                          <CButton
                            type="button"
                            class="custom-btn-navy mt-3"
                            block
                            size="lg"
                            @click="GoToThirdForm()"
                            >Next
                            <img
                              style="max-width: 30px"
                              src="../assets/img/subscription/ArrowWhite.png"
                              class="ml-3"
                          /></CButton>
                        </CCol>
                      </CRow>
                    </div>
                    <div v-if="sectionorganization === true">
                      <CRow class="text-center p-1 ml-3">
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle text-center float-right"
                            >1</span
                          >
                        </CCol>
                        <CCol sm="1" class="d-sm-down-none">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 100%"
                            class="mt-3"
                          />
                        </CCol>
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle text-center float-right"
                            >2</span
                          >
                        </CCol>
                        <CCol sm="1" class="d-sm-down-none">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            class="mt-3"
                            style="max-width: 100%"
                        /></CCol>
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle text-center float-right"
                            >3</span
                          ></CCol
                        >
                        <CCol sm="1" class="d-sm-down-none">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 100%"
                            class="mt-3"
                        /></CCol>
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle-grey text-center float-right"
                            >4</span
                          ></CCol
                        >

                        <br /><br />
                      </CRow>

                      <CRow class="mt-3 p-2" style="width: 100% !important">
                        <CCol sm="12">
                          <label>Enter your organization</label><br />
                          <CInput
                            type="text"
                            placeholder="Enter your organization"
                            size="lg"
                            v-model="Organization"
                          />
                          <label>Enter your description</label><br />
                          <CInput
                            type="Description"
                            placeholder="Enter your description"
                            size="lg"
                            v-model="Description"
                          />
                          <CButton
                            type="button"
                            class="custom-btn-navy mt-3"
                            block
                            size="lg"
                            @click="GoToEndForm()"
                            >Next
                            <img
                              style="max-width: 30px"
                              src="../assets/img/subscription/ArrowWhite.png"
                              class="ml-3"
                          /></CButton>
                        </CCol>
                      </CRow>
                    </div>
                    <div v-if="sectionconfirm === true">
                      <CRow class="text-center p-1 ml-3">
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle text-center float-right"
                            >1</span
                          >
                        </CCol>
                        <CCol sm="1" class="d-sm-down-none">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 100%"
                            class="mt-3"
                          />
                        </CCol>
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle text-center float-right"
                            >2</span
                          >
                        </CCol>
                        <CCol sm="1" class="d-sm-down-none">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            class="mt-3"
                            style="max-width: 100%"
                        /></CCol>
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle text-center float-right"
                            >3</span
                          ></CCol
                        >
                        <CCol sm="1" class="d-sm-down-none">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 100%"
                            class="mt-3"
                        /></CCol>
                        <CCol sm="2" style="width: 20%">
                          <span
                            class="custom-number-circle text-center float-right"
                            >4</span
                          ></CCol
                        >

                        <br /><br />
                      </CRow>

                      <CRow class="mt-3 p-2" style="width: 100% !important">
                        <CCol sm="12">
                          <h5>
                            <strong>Email :</strong> {{ this.Email }}
                            <br />
                            <strong> Phone : </strong>{{ this.Phone }}
                            <br />
                            <strong> Username :</strong> {{ this.Username }}
                            <br />
                            <strong>Organization :</strong>
                            {{ this.Organization }}
                            <br />
                            <strong>Description :</strong>{{ this.Description }}
                          </h5>
                          <CButton
                            type="button"
                            class="mt-3 custom-btn-success-subs"
                            color="success"
                            block
                            size="lg"
                            @click="SubmitAdmin()"
                            >{{ lblBtn }}</CButton
                          >

                        
                        </CCol>
                      </CRow>
                    </div>

                    <label>Once you successfully submit the information and pay based on package you choose, you can start login by click <a href="#" @click="GoToLogin()">here</a> </label>
                  </CCard>
                </div></CCol
              >
            </CRow>
          </div>
        </CCol>
      </CRow>
    </CJumbotron>
    <CJumbotron
      style="background-size: cover; height: 100vh; background-position: center"
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-xl-block d-sm-down-none d-lg-none"
    >
      <CRow>
        <br class="d-none d-lg-block d-xl-none" />
        <br class="d-none d-lg-block d-xl-none" />
        <CCol sm="12" lg="12">
          <div>
            <CRow>
              <CCol sm="8">
                <img
                  style="
                    max-width: 90%;
                    margin-left: 15%;
                    margin-bottom: 10%;
                    float: right;
                  "
                  src="../assets/img/subscription/banner1.svg"
                />
              </CCol>
              <CCol sm="4" class="custom-mt-25">
                <div style="width: 90%">
                  <h1 class="font-weight-700 custom-h1-subscribe">PICKIDDO</h1>
                  <h4 class="font-weight-700 sub-header-subscribe">
                    ADMIN DASHBOARD
                  </h4>
                  <CCard color="default" class="bg-card-default">
                    <h4 class="custom-label-text p-2">
                      Are you a large organization or interested in registering
                      multiple students? Please kindly complete the form below.
                    </h4>
                    <div v-if="sectionemail === true">
                      <CRow class="text-center p-1 ml-2">
                        <CCol sm="2">
                          <span
                            class="custom-number-circle text-center float-right"
                            >1</span
                          >
                        </CCol>
                        <CCol sm="1">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 20px"
                            class="mt-3"
                          />
                        </CCol>
                        <CCol sm="2">
                          <span
                            class="custom-number-circle-grey text-center float-right"
                            >2</span
                          >
                        </CCol>
                        <CCol sm="1">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            class="mt-3"
                            style="max-width: 20px"
                        /></CCol>
                        <CCol sm="2">
                          <span
                            class="custom-number-circle-grey text-center float-right"
                            >3</span
                          ></CCol
                        >
                        <CCol sm="1">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 20px"
                            class="mt-3"
                        /></CCol>
                        <CCol sm="2">
                          <span
                            class="custom-number-circle-grey text-center float-right"
                            >4</span
                          ></CCol
                        >

                        <br /><br />
                      </CRow>

                      <CRow class="mt-3 p-2" style="width: 100% !important">
                        <CCol sm="12">
                          <label>Enter your email</label><br />
                          <CInput
                            type="text"
                            placeholder="Enter your email"
                            size="lg"
                            v-model="Email"
                          />
                          <label>Enter your phone</label><br />
                          <CInput
                            type="text"
                            placeholder="Enter your phone"
                            size="lg"
                            v-model="Phone"
                          />
                          <CButton
                            type="button"
                            class="custom-btn-navy mt-3"
                            block
                            size="lg"
                            @click="GoToSecondForm()"
                            >Next
                            <img
                              style="max-width: 30px"
                              src="../assets/img/subscription/ArrowWhite.png"
                              class="ml-3"
                          /></CButton>
                        </CCol>
                      </CRow>
                    </div>
                    <div v-if="sectionusername === true">
                      <CRow class="text-center p-1 ml-2">
                        <CCol sm="2">
                          <span
                            class="custom-number-circle text-center float-right"
                            >1</span
                          >
                        </CCol>
                        <CCol sm="1">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 20px"
                            class="mt-3"
                          />
                        </CCol>
                        <CCol sm="2">
                          <span
                            class="custom-number-circle text-center float-right"
                            >2</span
                          >
                        </CCol>
                        <CCol sm="1">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            class="mt-3"
                            style="max-width: 20px"
                        /></CCol>
                        <CCol sm="2">
                          <span
                            class="custom-number-circle-grey text-center float-right"
                            >3</span
                          ></CCol
                        >
                        <CCol sm="1">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 20px"
                            class="mt-3"
                        /></CCol>
                        <CCol sm="2">
                          <span
                            class="custom-number-circle-grey text-center float-right"
                            >4</span
                          ></CCol
                        >

                        <br /><br />
                      </CRow>

                      <CRow class="mt-3 p-2" style="width: 100% !important">
                        <CCol sm="12">
                          <label>Enter your username</label><br />
                          <CInput
                            type="text"
                            placeholder="Enter your username"
                            size="lg"
                            v-model="Username"
                          />
                          <label>Enter your password</label><br />
                          <CInput
                            type="password"
                            placeholder="Enter your password"
                            size="lg"
                            v-model="Password"
                          />
                          <CButton
                            type="button"
                            class="custom-btn-navy mt-3"
                            block
                            size="lg"
                            @click="GoToThirdForm()"
                            >Next
                            <img
                              style="max-width: 30px"
                              src="../assets/img/subscription/ArrowWhite.png"
                              class="ml-3"
                          /></CButton>
                        </CCol>
                      </CRow>
                    </div>
                    <div v-if="sectionorganization === true">
                      <CRow class="text-center p-1 ml-2">
                        <CCol sm="2">
                          <span
                            class="custom-number-circle text-center float-right"
                            >1</span
                          >
                        </CCol>
                        <CCol sm="1">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 20px"
                            class="mt-3"
                          />
                        </CCol>
                        <CCol sm="2">
                          <span
                            class="custom-number-circle text-center float-right"
                            >2</span
                          >
                        </CCol>
                        <CCol sm="1">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            class="mt-3"
                            style="max-width: 20px"
                        /></CCol>
                        <CCol sm="2">
                          <span
                            class="custom-number-circle text-center float-right"
                            >3</span
                          ></CCol
                        >
                        <CCol sm="1">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 20px"
                            class="mt-3"
                        /></CCol>
                        <CCol sm="2">
                          <span
                            class="custom-number-circle-grey text-center float-right"
                            >4</span
                          ></CCol
                        >

                        <br /><br />
                      </CRow>

                      <CRow class="mt-3 p-2" style="width: 100% !important">
                        <CCol sm="12">
                          <label>Enter your organization</label><br />
                          <CInput
                            type="text"
                            placeholder="Enter your organization"
                            size="lg"
                            v-model="Organization"
                          />
                          <label>Enter your description</label><br />
                          <CInput
                            type="Description"
                            placeholder="Enter your description"
                            size="lg"
                            v-model="Description"
                          />
                          <CButton
                            type="button"
                            class="custom-btn-navy mt-3"
                            block
                            size="lg"
                            @click="GoToEndForm()"
                            >Next
                            <img
                              style="max-width: 30px"
                              src="../assets/img/subscription/ArrowWhite.png"
                              class="ml-3"
                          /></CButton>
                        </CCol>
                      </CRow>
                    </div>
                    <div v-if="sectionconfirm === true">
                      <CRow class="text-center p-1 ml-2">
                        <CCol sm="2">
                          <span
                            class="custom-number-circle text-center float-right"
                            >1</span
                          >
                        </CCol>
                        <CCol sm="1">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 20px"
                            class="mt-3"
                          />
                        </CCol>
                        <CCol sm="2">
                          <span
                            class="custom-number-circle text-center float-right"
                            >2</span
                          >
                        </CCol>
                        <CCol sm="1">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            class="mt-3"
                            style="max-width: 20px"
                        /></CCol>
                        <CCol sm="2">
                          <span
                            class="custom-number-circle text-center float-right"
                            >3</span
                          ></CCol
                        >
                        <CCol sm="1">
                          <img
                            src="../assets/img/subscription/Arrow.png"
                            style="max-width: 20px"
                            class="mt-3"
                        /></CCol>
                        <CCol sm="2">
                          <span
                            class="custom-number-circle text-center float-right"
                            >4</span
                          ></CCol
                        >

                        <br /><br />
                      </CRow>

                      <CRow class="mt-3 p-2" style="width: 100% !important">
                        <CCol sm="12">
                          <h5>
                            <strong>Email :</strong> {{ this.Email }}
                            <br />
                            <strong> Phone : </strong>{{ this.Phone }}
                            <br />
                            <strong> Username :</strong> {{ this.Username }}
                            <br />
                            <strong>Organization :</strong>
                            {{ this.Organization }}
                            <br />
                            <strong>Description :</strong>{{ this.Description }}
                          </h5>
                          <CButton
                            type="button"
                            class="mt-3 custom-btn-success-subs"
                            color="success"
                            block
                            size="lg"
                            @click="SubmitAdmin()"
                            >{{ lblBtn }}</CButton
                          >
                        </CCol>
                      </CRow>
                    </div>
                    <label>Once you successfully submit the information and pay based on package you choose, you can start login by click <a href="#" @click="GoToLogin()">here</a> </label>
                  </CCard>
                </div></CCol
              >
            </CRow>
          </div>
        </CCol>
      </CRow>
    </CJumbotron>
  </div>
</template>

<script>
import Vue from "vue";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";

import backgroundUrl from "../assets/img/bgSkill.png";
import backgroundBanner from "../assets/img/subscription/banner.svg";
import backgroundBannerUrl from "../assets/img/bg4.png";
import backgroundBannerReg from "../assets/img/bgReg.jpg";
import backgroundUrlNews from "../assets/img/update.jpg";
import backgroundUrlContact from "../assets/img/bgcontact.png";
import backgroundLearn from "../assets/img/bgLearn.png";

import AOS from "aos";
import "aos/dist/aos.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

export default {
  name: "ProClass",
  components: {
    Mainlayout,
    Footerlayout,
  },
  data() {
    return {
      backgroundUrl,
      backgroundBanner,
      backgroundBannerUrl,
      backgroundBannerReg,
      backgroundUrlNews,
      backgroundUrlContact,
      backgroundLearn,

      sectionemail: true,
      sectionusername: false,
      sectionorganization: false,

      Email: "",
      Phone: "",
      Username: "",
      Password: "",
      Organization: "",
      Description: "",
      lblBtn: "Submit",
    };
  },
  created() {
    AOS.init();
  },
  async mounted() {
    this.googleTranslateElementInit();
  },
  methods: {
    GoToSecondForm() {
      if (this.Email == "" && this.Phone == "") {
      } else {
        this.sectionemail = false;
        this.sectionusername = true;
      }
    },
    GoToThirdForm() {
      if (this.Username == "" && this.Password == "") {
      } else {
        this.sectionemail = false;
        this.sectionusername = false;
        this.sectionorganization = true;
      }
    },
    GoToEndForm() {
      this.sectionconfirm = true;

      this.sectionemail = false;
      this.sectionusername = false;
      this.sectionorganization = false;
    },
    async SubmitAdmin() {
      this.lblBtn = "Processing";
      this.Busy = true;

      if (
        this.$route.query.PackageId == 1 ||
        this.$route.query.PackageId == 8
      ) {
        const formData = new FormData();

        formData.append("Email", this.Email);
        formData.append("Username", this.Username);
        formData.append("PasswordHash", this.Password);
        formData.append("Description", this.Description);
        formData.append("Name", this.Organization);
        formData.append("PhoneNumber", this.Phone);
        formData.append("PackageId", this.$route.query.PackageId);

        return this.$API
          .post(this.$InsertSubscribePackageFree, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              window.open("https://ctr.pickiddo.com", "_self");
            } else {
              this.Busy = false;
              this.$dialog
                .alert("Error to create packages")
                .then(function () {});
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      } else {
        const formData = new FormData();

        formData.append("Email", this.Email);
        formData.append("Username", this.Username);
        formData.append("PasswordHash", this.Password);
        formData.append("Description", this.Description);
        formData.append("Name", this.Organization);
        formData.append("PhoneNumber", this.Phone);
        formData.append("PackageId", this.$route.query.PackageId);

        return this.$API
       .post(this.$InsertRegisterAdminSample, formData, {
       // .post(this.$InsertAdmin, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.billId = response.data;
              window.open(
                "https://www.billplz.com/bills/" + this.billId,
                "_self"
              );
             // this.SubmitAdminSuccessfull();
            } else {
              this.Busy = false;
              this.$dialog
                .alert("Error to create packagess")
                .then(function () {});
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },
    GoToLogin() {
        window.open("https://ctr.pickiddo.com/#/Login");
    },
    // SubmitAdminSuccessfull() {
    //   const formData = new FormData();

    //   formData.append("Email", this.Email);
    //   formData.append("Username", this.Username);
    //   formData.append("PasswordHash", this.Password);
    //   formData.append("Description", this.Description);
    //   formData.append("Name", this.Organization);
    //   formData.append("PhoneNumber", this.Phone);
    //   formData.append("PackageId", this.$route.query.PackageId);

    //   return this.$API
    //     .post(this.$InsertAdminSuccess, formData, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200) {
    //         this.billId = response.data;
    //         window.open("https://ctr.pickiddo.com", "_self");
    //       } else {
    //         this.Busy = false;
    //         this.$dialog
    //           .alert("Error to create packagess")
    //           .then(function () {});
    //       }
    //     })
    //     .catch((error) => {
    //       this.Busy = false;
    //       this.Loading = false;
    //       this.Error = true;
    //       this.Message = error.response.data.message;
    //     });
    // },
    
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&wght@700&family=Montserrat&family=Poppins&display=swap");

.h1.h2.h3.h4.h5.h6 {
  font-family: Montserrat;
}
.c-app {
  font-family: Montserrat;
}
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat";
}
</style>